var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_157_30)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.4917,
    cy: 47.0788,
    r: 38.4324,
    fill: "#B618FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.4917,
    cy: 47.0788,
    r: 40.8344,
    stroke: "white",
    strokeWidth: 4.80405
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.3768 59.0887C67.3768 62.6557 64.4583 65.5742 60.8913 65.5742C57.3243 65.5742 54.4058 62.6557 54.4058 59.0887H58.7295C58.7295 60.2777 59.7023 61.2506 60.8913 61.2506C62.0803 61.2506 63.0531 60.2777 63.0531 59.0887C63.0531 57.8997 62.0803 56.9269 60.8913 56.9269H40.354V52.6033H60.8913C64.4583 52.6033 67.3768 55.5217 67.3768 59.0887ZM77.1049 36.3896C77.1049 32.2173 73.7109 28.8232 69.5386 28.8232C65.3663 28.8232 61.9722 32.2173 61.9722 36.3896H66.2958C66.2958 34.5953 67.7443 33.1469 69.5386 33.1469C71.3329 33.1469 72.7813 34.5953 72.7813 36.3896C72.7813 38.1839 71.3329 39.6323 69.5386 39.6323H40.354V43.956H69.5386C73.7109 43.956 77.1049 40.5619 77.1049 36.3896ZM76.024 46.1178H40.354V50.4414H76.024C77.8184 50.4414 79.2668 51.8899 79.2668 53.6842C79.2668 55.4785 77.8184 56.9269 76.024 56.9269V61.2506C80.1964 61.2506 83.5904 57.8565 83.5904 53.6842C83.5904 49.5119 80.1964 46.1178 76.024 46.1178Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_157_30",
    x: -0.00000143051,
    y: -0.000463486,
    width: 113.375,
    height: 113.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.80405,
    dy: 9.60809
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.72566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_157_30"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_157_30",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAire);
export default __webpack_public_path__ + "static/media/ic_aire.0b4cd47e6fce023df48a490b5a52fb40.svg";
export { ForwardRef as ReactComponent };